export const ChatActionTypes = {
    LOGOUT: 'LOGOUT',

    CHAT_SEND_MESSAGE_REQUEST: 'CHAT_SEND_MESSAGE_REQUEST',
    CHAT_SEND_MESSAGE_REQUEST_SUCCESS: 'CHAT_SEND_MESSAGE_REQUEST_SUCCESS',
    CHAT_SEND_MESSAGE_REQUEST_ERROR: 'CHAT_SEND_MESSAGE_REQUEST_ERROR',
    CHAT_SEND_MESSAGE_REQUEST_STATUS: 'CHAT_SEND_MESSAGE_REQUEST_STATUS',

    CHAT_LIST_REQUEST: 'CHAT_LIST_REQUEST',
    CHAT_LIST_REQUEST_SUCCESS: 'CHAT_LIST_REQUEST_SUCCESS',
    CHAT_LIST_REQUEST_ERROR: 'CHAT_LIST_REQUEST_ERROR',

    MESSAGE_LIST_REQUEST: 'MESSAGE_LIST_REQUEST',
    MESSAGE_LIST_REQUEST_SUCCESS: 'MESSAGE_LIST_REQUEST_SUCCESS',
    MESSAGE_LIST_REQUEST_ERROR: 'MESSAGE_LIST_REQUEST_ERROR'
}
